package ir.yusefpasha.models

import ir.yusefpasha.util.Res

enum class Testimonial(
    val image: String,
    val fullName: String,
    val profession: String,
    val review: String,
    val rate: Int
) {
    First(
        image = Res.Image.AVATAR_1,
        fullName = "Paul Venkad",
        profession = "Business Man",
        review = "I'm Pavel and I wish you Yusef All the BEST",
        rate = 4
    ),
    Second(
        image = Res.Image.AVATAR_2,
        fullName = "John Doe",
        profession = "Actor",
        review = "I`m John and for you Yusef, I know that you have a good Future",
        rate = 4
    ),
    Third(
        image = Res.Image.AVATAR_3,
        fullName = "Sybli Noah",
        profession = "Musician",
        review = "I`m Sybil and for you Yusef, Good Lock",
        rate = 3
    ),
    Fourth(
        image = Res.Image.AVATAR_4,
        fullName = "Aida Senara",
        profession = "Developer",
        review = "I'm Aida and I wish you Yusef All the BEST",
        rate = 5
    ),
    Fifth(
        image = Res.Image.AVATAR_5,
        fullName = "Brayan Smorf",
        profession = "Researcher",
        review = "I`m Brayan and for you Yusef, I know that you have a good Future",
        rate = 3
    ),
    Sixth(
        image = Res.Image.AVATAR_6,
        fullName = "Jack Morfi",
        profession = "Manager",
        review = "I`m Jack and for you Yusef, Good Lock",
        rate = 2
    )
}